import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { Select } from '@workwave-tidal/core/components'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import React, { useCallback } from 'react'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { useFormikContext } from 'formik'

type Props = {
  options: IServiceFrequency[]
  name: string
  required?: boolean
}

export function ServiceFrequencySelect(props: Props) {
  const { options, name, required } = props
  const tidalThemeActive = useTidalThemeActive()

  const { setFieldValue } = useFormikContext()

  const onChange = useCallback(
    (value) => {
      setFieldValue(name, value)
    },
    [setFieldValue, name],
  )

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  return (
    <>
      <Select<IServiceFrequency | undefined>
        items={options}
        onChange={onChange}
        value={null}
        required={required}
        getLabel={(option) => {
          if (option) {
            return `${option.annualOccurrences} - ${option.description}`
          }
          return ''
        }}
        label="Frequency"
        disableClearOnBlur
        testId="frequencySelect"
        data-test-id="frequencySelect"
        listMode="normal"
        optionMode={'normal'}
        density={density}
        disabled={false}
        error={false}
      />
      {/* {isSalesFunnelValidationError && (
      <FormHelperText sx={{ ml: 1 }} error>
        {errors?.salesFunnelId}
      </FormHelperText>
    )} */}
    </>
  )
}
